import React from 'react';
import { Field } from 'redux-form';
import { connectSubpages } from 'app/hocs/subpageManagable';
import WrappedAutocomplete from '../../WrappedAutocomplete';
import CruiseSelectorScreen from './CruiseSelectorScreen';
import builder from '../builder';


/**
 * Mobile component for selecting Cruise Line
 */
export class MobileCruiseSelector extends React.Component {

  handleClick = () => {
    const { subpages, fieldName } = this.props;
    subpages.pushPage(CruiseSelectorScreen, { animation: 'lift', fieldName });
  }

  render() {
    return (
      <Field
        id={this.props.fieldName}
        skipIdForInput
        name={this.props.fieldName}
        component={WrappedAutocomplete}
        onClick={this.handleClick}
        readOnly
        {...this.props}
      />
    );
  }
}

// TODO: move to Flow types
// MobileCruiseSelector.propTypes = {
//   subpages: PropTypes.object.isRequired,
//   fieldName: PropTypes.string
// };

export default builder(
  connectSubpages()(MobileCruiseSelector)
);
